<div class="position-absolute" style="top: 30px; right: 30px">
  <div *ngFor="let import of pendingImports; let i = index" class="mb-3">
    <app-import-progress-toast
      [importId]="import['id']"
      [index]="i"
      (closeToastr)="onCloseToastr($event)"
    ></app-import-progress-toast>
  </div>
</div>
